import { useState, useEffect } from 'react'

export const useFetchInfoInterest = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal


    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoInterest = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/configuraciones/getInteresCredito/${formState.idinteres}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idinteres > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    
                    setFormState((prevState) => ({
                        ...prevState,
                        interes: data.interes || '',
                        descripcion: data.descripcion || '',
                    }))
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { executeFetchInfoInterest }
}

export const useFetchAllQuotations = ({marvarApi, dispatch, onLogout}) => {
    const [ loadinFetchQuotations, setLoadinFetchQuotations ] = useState(false)
    const [ quotes, setQuotes ] = useState([])
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllQuotations = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/herr-cotizador-credito`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadinFetchQuotations(true)
        fetchData()
            .then((resp) => {
                setQuotes(resp.data)
                setLoadinFetchQuotations(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setQuotes([])
                setLoadinFetchQuotations(false)
            })
    }, [execute])

    return { quotes, loadinFetchQuotations, executeFetchAllQuotations }

}

export const useFetchAllInterests = ({marvarApi, dispatch, onLogout}) =>{

    const [interests, setInterests] = useState([])

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllInterests = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/herr-cotizador-credito/interests`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    
                    setInterests(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { interests, executeFetchAllInterests }
}


export const useFetchInfoQuotation = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormRequestGlobal:{formState} } = Forms

    const [quotation, setQuotation] = useState([])

    // Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoQuotation = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/herr-cotizador-credito/quotation/${paramsToSearch.idcotizacion}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idcotizacion > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setQuotation(data)
                  
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { quotation, setParamsToSearch, executeFetchInfoQuotation }
}








